import { ResponseDataGet } from "../../../../models/responseDataGet";
import { agroApi } from "../../api";
import { Paths } from "../../../../paths";
import { EntBasicHB } from "../../../../models/handBooks/basicHB";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";

export const transportAccessApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getTransportAccessList: builder.query<ResponseDataGet<EntBasicHB>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.transportAccess }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getTransportAccessById: builder.query<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.transportAccess }/${ id }`,
		method: 'GET',
	  }),
	}),

	addTransportAccess: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.transportAccess }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editTransportAccess: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.transportAccess }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteTransportAccess: builder.mutation<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.transportAccess }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddTransportAccessMutation,
  useDeleteTransportAccessMutation,
  useEditTransportAccessMutation,
  useGetTransportAccessByIdQuery,
  useGetTransportAccessListQuery,
  useLazyGetTransportAccessListQuery
} = transportAccessApi;
